import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export interface GeoSearchResult {
  id: string;
  type: string;
  value: string;
  source: string;
  displayType: string;
  // Optional structured fields when BE returns richer location payloads.
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  timezone?: string;
  address?: {
    name?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: string;
    timezone?: string;
  };
}

type GeoSearchResponse = {
  results: GeoSearchResult[];
};

export async function getGeoSearch(
  query: string
): Promise<Result<GeoSearchResponse, ApiError>> {
  try {
    const response = await axios.get<GeoSearchResponse>(
      `/quote/ltl/geosearch?q=${encodeURIComponent(query)}`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getGeoSearch' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to search locations' });
    }

    return err({
      message: error.response?.data?.message || 'Failed to search locations',
      status: error.response?.status,
    });
  }
}
